/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteStatisticsPageChangesChartQueryVariables = GraphQL.Exact<{
  endDate: GraphQL.Scalars['DateYMD']['input'];
  scope: GraphQL.Scalars['String']['input'];
  startDate: GraphQL.Scalars['DateYMD']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteStatisticsPageChangesChartQuery = { readonly __typename?: 'Query', readonly dashboardData: { readonly __typename?: 'DashboardData', readonly pageChanges: { readonly __typename?: 'WebsiteDashboardPageChanges', readonly id: CK.ID, readonly pollInterval: number | null, readonly reasonForNoData: GraphQL.WebsiteDashboardReasonForNoData | null, readonly data: ReadonlyArray<{ readonly __typename?: 'WebsiteDashboardPageChangesData', readonly endDate: CK.DateYMD, readonly startDate: CK.DateYMD, readonly changes: ReadonlyArray<{ readonly __typename?: 'WebsiteDashboardPageChange', readonly changeType: GraphQL.PageChangeType, readonly numberOfPages: number }> }> | null } } };


export const WebsiteStatisticsPageChangesChartDocument = gql`
    query WebsiteStatisticsPageChangesChart($endDate: DateYMD!, $scope: String!, $startDate: DateYMD!, $websiteId: WebsiteId!) {
  dashboardData {
    pageChanges(
      endDate: $endDate
      scope: $scope
      startDate: $startDate
      websiteId: $websiteId
    ) {
      data {
        changes {
          changeType
          numberOfPages
        }
        endDate
        startDate
      }
      id
      pollInterval
      reasonForNoData
    }
  }
}
    `;

/**
 * __useWebsiteStatisticsPageChangesChartQuery__
 *
 * To run a query within a React component, call `useWebsiteStatisticsPageChangesChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStatisticsPageChangesChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteStatisticsPageChangesChartQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      scope: // value for 'scope'
 *      startDate: // value for 'startDate'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteStatisticsPageChangesChartQuery(baseOptions: Apollo.QueryHookOptions<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables> & ({ variables: WebsiteStatisticsPageChangesChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>(WebsiteStatisticsPageChangesChartDocument, options);
      }
export function useWebsiteStatisticsPageChangesChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>(WebsiteStatisticsPageChangesChartDocument, options);
        }
export function useWebsiteStatisticsPageChangesChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>(WebsiteStatisticsPageChangesChartDocument, options);
        }
export type WebsiteStatisticsPageChangesChartQueryHookResult = ReturnType<typeof useWebsiteStatisticsPageChangesChartQuery>;
export type WebsiteStatisticsPageChangesChartLazyQueryHookResult = ReturnType<typeof useWebsiteStatisticsPageChangesChartLazyQuery>;
export type WebsiteStatisticsPageChangesChartSuspenseQueryHookResult = ReturnType<typeof useWebsiteStatisticsPageChangesChartSuspenseQuery>;
export type WebsiteStatisticsPageChangesChartQueryResult = Apollo.QueryResult<WebsiteStatisticsPageChangesChartQuery, WebsiteStatisticsPageChangesChartQueryVariables>;